import { render, staticRenderFns } from "./questionSelect.vue?vue&type=template&id=df84c3f0&scoped=true&"
import script from "./questionSelect.vue?vue&type=script&lang=js&"
export * from "./questionSelect.vue?vue&type=script&lang=js&"
import style0 from "./questionSelect.vue?vue&type=style&index=0&id=df84c3f0&rel=stylesheet%2Fscss&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "df84c3f0",
  null
  
)

export default component.exports